import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import i18n from '@/initI18n';

import ResultTable from '@/precision-farming/application-maps/components/resultTable/ResultTable.vue';
import { ColumnSettings, TableData } from '@/precision-farming/application-maps/components/resultTable/types';
import { Zone } from '@/precision-farming/application-maps/store/baseWorkflowStore/types/Zone';
import type { ApplicationMapsState } from '@/precision-farming/application-maps/store/types';
import { useStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'TableZonesContainer',
  props: {
    workflowKey: null
  },
  setup(__props: any) {

const props = __props as { workflowKey: keyof ApplicationMapsState }

const t = i18n.translate;
const store = useStore();



const columns = ref<ColumnSettings[]>([
  {
    key: 'zone',
    header: {
      title: () => t('Zone') || 'Zone',
    },
    type: 'badge',
  },
  {
    key: 'value',
    header: {
      title: () => t('Wert') || 'Wert',
    },
    type: 'number',
  },
  {
    key: 'size',
    header: {
      title: () => t('Größe in ha') || 'Größe in ha',
    },
    type: 'number',
  },
]);

const zones = computed<Zone[]>(() => store.getters[`precisionFarming/applicationMaps/${props.workflowKey}/zones`]);
const totalArea = computed<number>(() => zones.value.map(({ size }) => size ?? 0).reduce((a, b) => a + b, 0));

const footer = computed<TableData>(() => ({
  zone: t('Total') || 'Total',
  value: '', // this is an index, and it doens't make sense to display the sum of it
  size: totalArea.value,
}));

const tableData = computed<TableData[]>(() =>
  zones.value.map(
    (zone: Zone): TableData => ({
      zone,
      value: zone.rate,
      size: zone.size,
    }),
  ),
);

return { __sfc: true,t, store, props, columns, zones, totalArea, footer, tableData, ResultTable }
}

})